import { Component, EventEmitter, Injector, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DispatchService } from '../../dispatch/dispatch.service';
import { DriversService } from '../../drivers/drivers.service';
import { OnDemandDriversService } from '../../on-demand-drivers/on-demand-drivers.service';
import { ProvidersService } from '../../providers/providers.service';
import { VehiclesService } from '../../vehicles/vehicles.service';
import { ReservationService } from '../reservations.service';
import { Subscription } from 'rxjs/Subscription';
import {
  assignNewArray,
  resetServiceEnabled,
  verifyServiceEnabled
} from '../../A2-utils/export-functions/functions-services';
import { IVehicle } from '../../../core/interfaces/vehicle.interface';
import { IDriver } from '../../../core/interfaces/driver.interface';
import * as moment from 'moment';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { MultiSelectComponent } from 'ng-multiselect-dropdown';

interface IMultiselectItem {
  id: number;
  value: string;
}

@Component({
  selector: 'app-trip-edit-driver-vehicle',
  templateUrl: './trip-edit-driver-vehicle.component.html',
  styleUrls: ['./trip-edit-driver-vehicle.component.scss']
})
export class TripEditDriverVehicleComponent  extends ParentModule implements OnInit, OnChanges, OnDestroy {
  @Input() companyId = 0;
  @Input() tripId = 0;
  @Input() driverId = 0;
  @Input() vehicleId = 0;
  @Input() DOS = '2018-05-22';
  @Input() isStandingOrder: boolean;
  @Input() standingOrderId: number;
  @Input() payorauthorization: string;
  private observables: Subscription[] = [];

  @Input() fromCompleted = false;

  @Output() response = new EventEmitter<any>();
  @Input() standingOrderDate: any;

  private selectedVehicle = 0;
  private selectedDriver = 0;
  private drivers: any[];
  private vehicles: any[];
  public vehicleDropdownList: IMultiselectItem[] = [];
  public driverDropdownList: IMultiselectItem[] = [];
  public vehicleSelectedList: IMultiselectItem[] = [];
  public driverSelectedList: IMultiselectItem[] = [];
  @ViewChild('vehicleDropdown') private vehicleDropdown: MultiSelectComponent;
  @ViewChild('driverDropdown') private driverDropdown: MultiSelectComponent;
  public dropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'value',
    itemsShowLimit: 1,
    allowSearchFilter: true,
    enableCheckAll: true,
    closeDropDownOnSelection: true,
    searchPlaceholderText: 'Search'
  };
  private temVehicle: any;
  private disableButton = false;
  public showLoading = false;
  public showFullName = false;

  private isCompanyOnDemand = false;
  private vehiclesisStandingOrder: any[];
  protected UnSchedule = false;

  authSo = false;
  Authorization: string;
  dateRange: any;
  showDateRange: boolean;
  showPayorAuthorization: boolean;
  constructor(
    protected service: ReservationService,
    protected dispatchService: DispatchService,
    protected companyService: ProvidersService,
    protected vehicleService: VehiclesService,
    protected driverService: DriversService,
    protected onDemandDriverService: OnDemandDriversService,
    protected Inject: Injector,
    private sweetAlertHelper: SweetAlertHelper,
    protected loading: T2LoadingService,
    ) {
    super('app-edit-reservation-form', Inject);
  }

  ngOnInit() {
    if (this.isStandingOrder) {
      this.showDateRange = true;
    }       
    this.UnSchedule = this.isStandingOrder;

    this.observables.push(
      this.actionsList$.subscribe((response) => {
        if (response && response.length) {
          this.showPayorAuthorization = response.includes(
            'AuthorizationEnabled'
          );
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.isStandingOrder) {
      this.showDateRange = false;
    }
    // tslint:disable-next-line:forin
    for (const input in changes) {
      this.defineWhichMethodExecute(input, changes[input]);
    }
  }

  /**
   * @name defineWhichMethodExecute
   * @description verifica los datos de entrada y ejecuta el metodo adecuado.
   * @param input: el nombre del input de entrada
   * @param change: el change del input
   */
  defineWhichMethodExecute(input, change) {
    if (input === 'companyId' && change.currentValue) {
      this.getCompanyData();
    }
    if (input === 'driverId' && change.currentValue) {
      this.onChangeDriver(this.driverId);
      this.selectedDriver = this.driverId;
      this.syncDriverSelection();
    }
    if (input === 'vehicleId' && change.currentValue) {
      this.selectedVehicle = this.vehicleId;
      this.syncVehicleSelection();
      this.setVehicleAndDriverIdAndSendToAnotherComponents();
    }
  }

  private setVehicleAndDriverIdAndSendToAnotherComponents(vehicle = null, driver = null) {
    this.service.setVehicleIdAndDriverId({
      driverId: driver || this.selectedDriver,
      vehicleId: vehicle || this.selectedVehicle
    });
  }

  private getCompanyData() {
    this.observables.push(
      this.companyService.getCompany(this.companyId).subscribe(
        data => {
          this.isCompanyOnDemand = data.ondemand;
          this.getData();
        }
      ));
  }

  /**`
   * this execute when vehicle is changed
   */
  onChangeVehicle(event) {
    if (!event) {
      this.selectedDriver = null;
      this.syncDriverSelection();
      return;
    }
    if (!this.isStandingOrder) {
      const vehicle: IVehicle = this.vehicles.find(f => f.vehicleid === event);
      this.selectedDriver = vehicle.driverid;
      this.authSo = this.authorizationRequired(vehicle.hasintegration);
    } else {
      this.selectedDriver = this.vehicles.find(item => item.vehicleid === event).userprofileid;
      const hasIntegration = this.vehicles.find(item => item.vehicleid === event).hasintegration;
      this.authSo = this.authorizationRequired(hasIntegration);
    }

    this.authoration();
    this.syncDriverSelection();
    this.setVehicleAndDriverIdAndSendToAnotherComponents(event);
  }

  onVehicleSelectionChange(selected: IMultiselectItem[]) {
    const raw = selected && selected.length ? selected[0].id : null;
    const id = raw === -1 ? null : raw;
    if (id === this.selectedVehicle) {
      return;
    }
    this.selectedVehicle = id;
    this.onChangeVehicle(id);
  }

  onDriverSelectionChange(selected: IMultiselectItem[]) {
    const raw = selected && selected.length ? selected[0].id : null;
    const id = raw === -1 ? null : raw;
    if (id === this.selectedDriver) {
      return;
    }
    this.selectedDriver = id;
    if (id === null) {
      this.selectedVehicle = null;
      this.syncVehicleSelection();
      this.setVehicleAndDriverIdAndSendToAnotherComponents();
      return;
    }
    this.onChangeDriver(id);
  }

  private buildVehicleDropdown(): void {
    const vehicles = this.vehicles || [];

    this.vehicleDropdownList = [{ id: -1, value: 'Unassigned' }].concat(vehicles
      .filter((veh) => veh && veh.vehicleid)
      .map((veh) => {
        const driverLabel =
          this.isCompanyOnDemand && veh.driver && veh.driver.fullname
            ? veh.driver.fullname
            : this.viewDriver(veh.driver);

        return {
          id: veh.vehicleid,
          value: veh.code + ' | ' + driverLabel
        } as IMultiselectItem;
      }));
    this.syncVehicleSelection();
  }

  private buildDriverDropdown() {
    const list: IMultiselectItem[] = [{ id: -1, value: 'Unassigned' }];
    if (this.drivers && this.drivers.length) {
      this.drivers.forEach((driver) => {
        if (driver && driver.userprofileid) {
          list.push({
            id: driver.userprofileid,
            value: driver.fullname + (driver.phone ? ' - ' + driver.phone : '')
          });
        }
      });
    }
    this.driverDropdownList = list;
    this.syncDriverSelection();
  }

  private syncVehicleSelection() {
    const id = this.selectedVehicle === null ? -1 : this.selectedVehicle;
    const found = this.vehicleDropdownList.find((item) => item.id === id);
    this.vehicleSelectedList = found ? [found] : [];
  }

  private syncDriverSelection() {
    const id = this.selectedDriver === null ? -1 : this.selectedDriver;
    const found = this.driverDropdownList.find((item) => item.id === id);
    this.driverSelectedList = found ? [found] : [];
  }

  authorizationRequired(hasIntegration: boolean): boolean {
    return this.showPayorAuthorization && hasIntegration;
  }

  authoration() {
    this.payorauthorization && this.authSo ? this.Authorization = this.payorauthorization : null;
  }

    /**
     * this execute when driver is changed
     * @servise Vehicle/ListByDriverId/driverId
     */
    private onChangeDriver(driverId) {
      if (!this.isStandingOrder || this.isCompanyOnDemand) {
        this.showLoading = true;
        this.observables.push(
        this.vehicleService.getVehiclesByDriver(driverId).subscribe(
          data => {
            this.showLoading = false;
            this.vehicles = data;
            this.temVehicle = data;
            this.selectedVehicle = this.filterPreScheduled(data);
            this.buildVehicleDropdown();
            this.setVehicleAndDriverIdAndSendToAnotherComponents();
          },
          error => {
            this.showLoading = false;
          }
        ));
      }
    }

  /**
   * vehicle filtering with preScheduled attribute
   * @param vehicles
   */
  private filterPreScheduled(vehicles) {
    return (vehicles.filter(f => f.prescheduled === true).length) ?
      vehicles.filter(f => f.prescheduled === true).shift().vehicleid :
      vehicles[0].vehicleid;
  }

  /**
   * @name getDriverOnDemend
   * @description Trae los Driver si la compañia es on demand
   * @servise /Trip2Driver/List?applicationStatusId=33&showInactive=false&filter=
   */
  getDriverOnDemend() {
    this.observables.push(
    this.onDemandDriverService.getFilterDriver('', false, 33).subscribe(
      data => {
        this.drivers = data;
        this.buildDriverDropdown();
        this.showLoading = false;
      },
      () => {
        this.showLoading = false;
      }
    ));
  }

  /**
   * @name getDriverIsSO
   * @description Trae los Driver si es un Standing Order
   * @servise MCTDriver/ListByFilter/?filter=&providerid=this.companyId&showInactive=false
   */
  getDriverIsSO() {
    this.observables.push(
    this.service.getDriversProviderAllByProvider(this.companyId, 4)
      .subscribe(
        data => {
          this.drivers = data;
          this.buildDriverDropdown();
    this.showLoading = false;
        }));
  }

  /**
   * @name getVehicleIsSO
   * @description Trae los Vehiculos si es un Standing Order
   * @servise Vehicle?showDisable=false&code=&ondemand=false&providerId=this.companyId&vehicleCycleId=&orderByDriver=false
   */
  getVehiclesIsSO() {
    this.observables.push(
      this.service
        .getVehicleByProviderNoOndemand(this.companyId, false)
        .subscribe((data: any[]) => {
          this.vehiclesisStandingOrder = [];
        data.forEach( f => {
          this.verifyVehiclesAndDrivers(f);
        });
          this.vehicles = this.vehiclesisStandingOrder;
          this.buildVehicleDropdown();
    this.showLoading = false;
      }));
  }

  /**
   * @name getDriverNotOnDemand
   * @description Trae los driver si es un Not on Demand y no es SO
   * @servise Trip/TripsDriversByFilters{dateofservice, this.companyId, depotids, isschedule, orderby, createSchedule}
   */
  getDriverNotOnDemand() {
    this.observables.push(
    this.dispatchService.getTripsDriversByFilters(this.DOS, false, this.companyId)
      .subscribe(
        data => {
          this.temVehiclepush(data);
          this.showLoading = false;
        },
        error => {
    this.showLoading = false;
        }
        ));
  }


  /**
   * @name getVehicleNotOnDemand
   * @description Trae los vehiculos si es un Not on Demand y no es SO
   * @servise MCTdriver/List
   */
  getVehicleNotOnDemand() {
    this.observables.push(
    this.driverService.getDriversMCTAll().subscribe(
      data => {
        this.drivers = data;
        this.buildDriverDropdown();
        this.showLoading = false;
      },
      error => {
        this.showLoading = false;
      }
    ));
  }

  /**
   * @name getData
   * @description Trae los vehiculos y driver segun se valide - get vehicle and driver data from server
   */
    private getData() {
      this.showLoading = true;
      if (this.isCompanyOnDemand) {this.getDriverOnDemend(); } else {
        if (this.isStandingOrder) {
          this.getDriverIsSO();
          this.getVehiclesIsSO();
        } else {
          this.getDriverNotOnDemand();
         /* this.getVehicleNotOnDemand();*/
        }

      }
     /* this.resetSelected();*/
    }
    private resetSelected(): void {
      this.selectedVehicle = 0;
      this.selectedDriver = 0;
    }
  /**
   * @Metodo temVehiclepush
   * @description mantiene visible el Veicle que tiene la reserva
   * */
    temVehiclepush(data) {
      this.vehicles = [];
      if (data.length > 1) {
        this.vehicles = data;
      } else {
        if (this.temVehicle) {
          this.vehicles = assignNewArray(this.temVehicle);
        }
      }
      this.buildVehicleDropdown();
    }

  /**
   * @Metodo verifyVehiclesAndDrivers
   * @description Verifica que el vehículo traiga un driver si no es SO - Verify that the vehicle brings a driver
   * */
    verifyVehiclesAndDrivers(vehicle) {
      if (this.UnSchedule) {
        if (this.isStandingOrder) {this.pushDriverAndVehicle(vehicle); }
      }else {
        if (vehicle.driver) {
          this.pushDriverAndVehicle(vehicle);
        }
      }
    }

  /**
   * @Metodo pushDriverAndVehicle
   * @description
   * */
 pushDriverAndVehicle(vehicle) {
   this.vehiclesisStandingOrder.push({
     'vehicleid': vehicle.vehicleid, 'code': vehicle.code, 'driver': vehicle.driver ? vehicle.driver.fullname : '',
     'userprofileid': vehicle.driverid ? vehicle.driverid :
       ( vehicle.driver ? vehicle.driver.driverid : ''), 'hasintegration': vehicle.hasintegration
   });
 }
    /**
     * this clear vehicle and driver data
     */
    private clearDriverAndVehicle() {
        this.selectedVehicle = null;
        this.selectedDriver = null;
        this.vehicleSelectedList = [];
        this.driverSelectedList = [];
        this.authSo = false;
        if (this.vehicleDropdown) {
          this.vehicleDropdown.selectedItems = [];
        }
        if (this.driverDropdown) {
          this.driverDropdown.selectedItems = [];
        }
    }

    messagError(){
      this.sweetAlertHelper.createCustomAlert({title: 'Error', text: 'Authorization is required', type: 'error'});
      this.disableButton = false;
      return;
    }
    /**
     * save company action
     */
  private save() {
    this.disableButton = true;
    if (this.isStandingOrder && this.UnSchedule) {
      this.setAllLeg().then(allLegs => {
        if (allLegs) {
          const object = {
            StandingOrderTripId: this.tripId,
            DriverId: this.selectedDriver,
            VehicleId: this.selectedVehicle,
            allLegs: allLegs.value ? true : false,
            startdatechanges: this.dateRange ? this.dateRange.starDate : '',
            enddatechanges: this.dateRange ?  this.dateRange.endDate : ''
          };
          if (this.authSo) {
            if (this.Authorization)
            {
              object['authorization'] = this.Authorization;
            } else {
              this.messagError();
              return;
            }
          }
          if (verifyServiceEnabled('editVehicleAndDriverSO')) {
            this.loading.show();
            this.observables.push(
              this.service.editVehicleAndDriverSO(object)
                .finally(() => this.loading.hiden())
                .subscribe(
                  data => {
                    data.newVehicle = this.selectedVehicle;
                    data.newDriver = this.selectedDriver;
                    this.response.emit(data);
                    resetServiceEnabled('editVehicleAndDriverSO');
                    this.disableButton = false;
                  },
                  err => {
                    this.response.emit(err);
                    resetServiceEnabled('editVehicleAndDriverSO');
                  }
              )
            );
          }
        } else {
          this.disableButton = false;
        }

      });
    } else {
      const object = {
        tripid: this.tripId,
        olddriverid: this.driverId,
        newdriverid: this.selectedDriver,
        oldvehicleid: this.vehicleId,
        newvehicleid: this.selectedVehicle
      };
      if (this.authSo) {
        if (this.Authorization) {
          object['authorization'] = this.Authorization;
        } else {
          this.messagError();
          return;
        }
      }
      if (verifyServiceEnabled('VehicleAndDriver')) {
        this.loading.show();
        this.observables.push(
          this.service.editVehicleAndDriver(object)
            .finally(() => this.loading.hiden())
            .subscribe(
              data => {
                data.newVehicle = this.selectedVehicle;
                data.newDriver = this.selectedDriver;
                resetServiceEnabled('VehicleAndDriver');
                this.disableButton = false;
                this.response.emit(data);
              },
              err => {
                this.response.emit(err);
                resetServiceEnabled('VehicleAndDriver');
              }
            ));
      }
    }
  }

    public getObjectData() {
        return {
            driverid: this.selectedDriver,
            vehicleid: this.selectedVehicle
        };
    }

    /**
   * this send trips to mct from DHP
   */
 /* dhpAuth: string;
  sendTripToMCT() {
    const data = [{
      tripid: this.tripId,
      authorization: this.dhpAuth
    }];
    this.observables.push(
    this.service.sendTripToMCT(data).subscribe(
      (res) => {
        Swal(res.importlogs, '', 'success');
        this.save();
      },
      error => {
        toastr.error(error.message);
      }
    ));
  } */

  /**
   * this validate if authorization is needed
   */
 /*  validateAuth() {
      if (this.isDHP) {
         //this.authModal.open();
      } else {
        this.sendTripToMCT();
      }
  } */

  setAllLeg() {
    return this.sweetAlertHelper.createCustomAlert({
      text: 'Do you want to change the vehicle and driver for all legs?',
      type: 'info',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    });
  }
  /**
   * @name viewDriver
   * @description retorna name de driver
   * @param driver
   */
  viewDriver(driver: (string | IDriver)): string {
    let value = '';
    if (typeof driver === 'string') {
      value = driver;
    } else if (typeof driver === 'object') {
      value = driver.fullname;
    }
    return value;
  }

  onChangeDateRange(event: any) {
    if (event) {
      if (!event.formatted) {
        const startDate =
          `${this.standingOrderDate.beginDate.year}-${this.standingOrderDate.beginDate.month}-${this.standingOrderDate.beginDate.day}`;
        const endDate =
          `${this.standingOrderDate.endDate.year}-${this.standingOrderDate.endDate.month}-${this.standingOrderDate.endDate.day}`;
        this.setDateRange(startDate, endDate);
      } else {
        const slice = event.formatted.split(' ');
        this.setDateRange(slice[0], slice[2]);
      }
    } else {
      this.setDateRange(null, null);
    }
  }

  setDateRange(startDate, endDate) {
    this.dateRange = {
      starDate: startDate ? moment(startDate).format('MM-DD-YYYY') : '',
      endDate: endDate ? moment(endDate).format('MM-DD-YYYY') : ''
    };
  }

  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/trip-edit-driver-vehicle/trip-edit-driver-vehicle.component.ts